import React, { useCallback, useEffect, useRef, useState } from 'react'
import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  message,
  Modal,
  Row,
  Select,
  Space,
  Tag,
  Tooltip,
  Upload,
} from 'antd'
import RichEditor from '../../../components/RichEditor/RichEditor'
import {
  ASSIGNEE_TYPE,
  DATE_FORMAT_LIST,
  DOCUMENT_TYPE,
  WORK_STATUS,
} from '../../../constants'
import {
  SelectList,
  SelectTitle,
} from '../../MissionCreatePage/MissionCreatePageStyled'
import { blue, yellowPrimary } from '../../../color'
import {
  BankOutlined,
  CloseOutlined,
  DeleteOutlined,
  FileTextOutlined,
  SendOutlined,
  TeamOutlined,
  UploadOutlined,
  UserOutlined,
} from '@ant-design/icons'
import { AvatarHasName } from '../../../components/Common/Avatar'
import {
  ButtonFooter,
  UploadFileListItem,
  UploadFileListWrapper,
} from '../../WorkPage/PopupWorkForm/PopupWorkFormStyled'
import SelectPeoplePopup from '../../../components/SelectPeoplePopup/SelectPeoplePopup'
import SelectGroupPopup from '../../../components/SelectGroupPopup/SelectGroupPopup'
import moment from 'moment'
import { inject, observer } from 'mobx-react'
import utils from '../../../utils'

const { Option } = Select

const PopupPhanPhatDocument = props => {
  const {
    isVisiblePopupPhanPhatDocument,
    handleClosePopupPhanPhatDocument,
    fileStore,
    workStore,
    loadingAnimationStore,
    selectPeopleStore,
    internalDocumentStore,
    commentLeaderList,
    selectedInternalDocument,
    typeDocument,
  } = props
  const {
    userAssignList,
    departmentAssignList,
    groupAssignList,
  } = internalDocumentStore
  const {
    incoming_number,
    code,
    document_status,
    title,
    attachments,
  } = selectedInternalDocument

  const start_date_origin = selectedInternalDocument.start_date
  const end_date_origin = selectedInternalDocument.end_date

  const { workTypeList } = workStore

  const {
    selectUserData,
    selectDepartmentData,
    selectGroupData,
    isVisibleSelectGroupPopup,
    setIsVisibleSelectGroupPopup,
    isVisibleSelectUserDepartmentPopup,
    setIsVisibleSelectUserDepartmentPopup,
    handleOpenSelectUserDepartmentPopup,
    handleCancelSelectUserDepartment,
    handleOpenSelectGroupPopup,
    handleCancelSelectGroup,
  } = selectPeopleStore

  const [form] = Form.useForm()
  const EDITOR_REF = useRef()

  const [editorContent, setEditorContent] = useState()
  const [handlerList, setHandlerList] = useState([])
  const [followerList, setFollowerList] = useState([])
  const [fileList, setFileList] = useState([])
  const [documentList, setDocumentList] = useState([])

  useEffect(() => {
    setHandlerList([
      ...selectUserData[ASSIGNEE_TYPE.COMBINER],
      ...selectDepartmentData[ASSIGNEE_TYPE.COMBINER],
      ...selectGroupData[ASSIGNEE_TYPE.COMBINER],
    ])
    setFollowerList([
      ...selectUserData[ASSIGNEE_TYPE.FOLLOWER],
      ...selectDepartmentData[ASSIGNEE_TYPE.FOLLOWER],
      ...selectGroupData[ASSIGNEE_TYPE.FOLLOWER],
    ])
  }, [selectUserData, selectDepartmentData, selectGroupData])

  const handleChangeFile = useCallback(info => {
    const filteredFileList = info.fileList.filter(
      (elem, index, fileArray) =>
        fileArray.findIndex(file => file.name === elem.name) === index
    )
    setFileList(filteredFileList)
  }, [])

  const onFinish = useCallback(async value => {
    const { title, start_date, due_date, work_type } = value
    if (handlerList.length === 0)
      return message.warning('Bạn chưa chọn người xử lý!')
    const dataSubmitHandleDocument = {
      new_items: [],
      remove_items: [],
      start_date:
        !start_date_origin || moment(start_date).isBefore(start_date_origin)
          ? start_date
          : start_date_origin,
      end_date:
        !end_date_origin || moment(due_date).isAfter(end_date_origin)
          ? due_date
          : end_date_origin,
      document_status: document_status,
    }
    // Tạo công việc
    const assigneesList = [
      ...followerList,
      ...handlerList.map(handler => ({
        ...handler,
        permission: ASSIGNEE_TYPE.HANDLER,
      })),
    ].map(el => ({
      assignee_code: el.id,
      assignee_type: el.assignee_type,
      permission: el.permission,
    }))
    const batchUploadArr = []
    fileList.forEach(file => {
      const formData = new FormData()
      formData.append('file', file.originFileObj)
      batchUploadArr.push(fileStore.uploadFile(formData))
    })
    try {
      loadingAnimationStore.showSpinner(true)
      await internalDocumentStore.updateAssignees(
        code,
        dataSubmitHandleDocument
      )
      const response = await Promise.all(batchUploadArr)
      const dataSubmitWork = {
        title: title,
        start_date: start_date,
        related_documents:
          code && typeDocument
            ? [
                {
                  code: code,
                  type: typeDocument,
                },
              ]
            : [],
        related_tasks: [],
        due_date: due_date,
        content: EDITOR_REF.current.editor.getData(),
        attachments: response
          .map(response => response.data.file_id)
          .concat(documentList.map(file => file.id)),
        assignees: assigneesList,
        parent_id: null,
        work_type: work_type,
      }
      await workStore.createWork(dataSubmitWork)
      if (typeDocument === DOCUMENT_TYPE.INCOMING) {
        await internalDocumentStore.getInternalDocumentIncomingById(code)
      }
      if (typeDocument === DOCUMENT_TYPE.OUTGOING) {
        await internalDocumentStore.getInternalDocumentOutgoingById(code)
      }
      selectPeopleStore.clearSelected()
      handleClosePopupPhanPhatDocument()
      message.success('Phân phát văn bản thành công!')
    } catch (err) {
      console.log(err)
      message.error(err?.vi || 'Đã có lỗi xảy ra!')
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }, [
    code,
    documentList,
    document_status,
    end_date_origin,
    fileList,
    fileStore,
    followerList,
    handleClosePopupPhanPhatDocument,
    handlerList,
    internalDocumentStore,
    loadingAnimationStore,
    selectPeopleStore,
    start_date_origin,
    typeDocument,
    workStore,
  ])

  const handleCancel = useCallback(() => {
    form.resetFields()
    setFileList([])
    handleClosePopupPhanPhatDocument()
  }, [form, handleClosePopupPhanPhatDocument])

  useEffect(() => {
    selectPeopleStore.clearSelected()
    setDocumentList(attachments || [])
    const comments_leader =
      commentLeaderList && commentLeaderList.length > 0
        ? commentLeaderList.map(cmt => cmt.content)
        : ''
    const leader_name =
      commentLeaderList && commentLeaderList.length > 0
        ? utils.getNameInCapitalize(commentLeaderList[0].name_uppercase)
        : ''
    form.setFieldsValue({
      work_type: WORK_STATUS.DOCUMENT,
      title: `Xử lý văn bản ${
        incoming_number ? 'đến ' + incoming_number : 'đi'
      }: ${title}`,
      content: setEditorContent(
        `Nội dung: ${title + '. \n'}${leader_name} ${comments_leader}`
      ),
      start_date: start_date_origin && moment(start_date_origin),
      due_date: end_date_origin && moment(end_date_origin),
    })
  }, [
    selectedInternalDocument,
    commentLeaderList,
    isVisiblePopupPhanPhatDocument,
  ])

  return (
    <>
    <Modal
      width={800}
      style={{ top: 40, zIndex: 9999 }}
      wrapClassName="distribute-modal-custom"
      title={
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}>
          <span style={{ color: '#333', fontSize: 20, fontWeight: 600 }}>Phân phát văn bản</span>
          <Button
            icon={<CloseOutlined />}
            type={'text'}
            onClick={handleCancel}
          />
        </div>
      }
      visible={isVisiblePopupPhanPhatDocument}
      closable={false}
      footer={null}>
      <Form onFinish={onFinish} form={form} layout="vertical" className="distribute-form-custom">
        <Form.Item
          label={<span style={{ fontWeight: 500 }}>Loại công việc</span>}
          name={'work_type'}
          rules={[{ required: true, message: 'Vui lòng chọn loại công việc' }]}>
          <Select placeholder={'-- Chọn loại công việc --'} style={{ height: 40, borderRadius: 8 }}>
            {workTypeList.map(workType => (
              <Option
                key={workType.id}
                value={workType.id}
                name={workType.name}>
                {workType.name}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          label={<span style={{ fontWeight: 500 }}>Tiêu đề:</span>}
          name={'title'}
          rules={[
            { required: true, message: 'Vui lòng nhập tiêu đề' },
            { max: 500, message: 'Tiêu đề không được dài quá 500 ký tự!' },
          ]}>
          <Input placeholder={'Nhập tiêu đề...'} style={{ height: 40, borderRadius: 8 }} />
        </Form.Item>

        <Form.Item label={<span style={{ fontWeight: 500 }}>Nội dung:</span>} name={'content'}>
          <RichEditor
            EDITOR_REF={EDITOR_REF}
            placeholder={'Nhập nội dung...'}
            editorContent={editorContent}
            style={{ borderRadius: 8 }}
          />
        </Form.Item>

        <Row gutter={[24, 24]}>
          <Col span={12}>
            <Form.Item
              label={<span style={{ fontWeight: 500 }}>Ngày bắt đầu:</span>}
              rules={[
                { required: true, message: 'Vui lòng chọn ngày bắt đầu!' },
              ]}
              name={'start_date'}>
              <DatePicker format={DATE_FORMAT_LIST} style={{ width: '100%', height: 40, borderRadius: 8 }} placeholder="Chọn thời điểm" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label={<span style={{ fontWeight: 500 }}>Ngày kết thúc:</span>} name={'due_date'}>
              <DatePicker format={DATE_FORMAT_LIST} style={{ width: '100%', height: 40, borderRadius: 8 }} placeholder="Chọn thời điểm" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[24, 24]}>
          <Col span={12}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
              <span style={{ fontWeight: 500 }}>
                <span style={{ color: 'red' }}>* </span>Người xử lý:
              </span>
              <Space>
                <Button
                  icon={<UserOutlined style={{ color: blue }} />}
                  onClick={() => handleOpenSelectUserDepartmentPopup(ASSIGNEE_TYPE.COMBINER)}
                  style={{ borderRadius: 8 }}
                />
                <Button
                  icon={<TeamOutlined />}
                  style={{ color: yellowPrimary, borderRadius: 8 }}
                  onClick={() => handleOpenSelectGroupPopup(ASSIGNEE_TYPE.COMBINER)}
                />
              </Space>
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
              {handlerList.map(el => (
                <Tag
                  className={'tag-selected'}
                  color={'blue'}
                  key={el.id}
                  closable
                  style={{ margin: 2, borderRadius: 4 }}
                  onClose={() => selectPeopleStore.handleRemoveSelect(el)}>
                  <AvatarHasName
                    imgId={el.image_id}
                    size={20}
                    name={el.full_name}
                    icon={
                      (el.assignee_type === ASSIGNEE_TYPE.DEPARTMENT && <BankOutlined />) ||
                      (el.assignee_type === ASSIGNEE_TYPE.GROUP && <TeamOutlined />)
                    }
                  />
                </Tag>
              ))}
            </div>
          </Col>

          <Col span={12}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
              <span style={{ fontWeight: 500 }}>Người theo dõi:</span>
              <Space>
                <Button
                  icon={<UserOutlined style={{ color: blue }} />}
                  onClick={() => handleOpenSelectUserDepartmentPopup(ASSIGNEE_TYPE.FOLLOWER)}
                  style={{ borderRadius: 8 }}
                />
                <Button
                  icon={<TeamOutlined />}
                  style={{ color: yellowPrimary, borderRadius: 8 }}
                  onClick={() => handleOpenSelectGroupPopup(ASSIGNEE_TYPE.FOLLOWER)}
                />
              </Space>
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
              {followerList.map(el => (
                <Tag
                  className={'tag-selected'}
                  color={'blue'}
                  key={el.id}
                  closable
                  style={{ margin: 2, borderRadius: 4 }}
                  onClose={() => selectPeopleStore.handleRemoveSelect(el)}>
                  <AvatarHasName
                    imgId={el.image_id}
                    size={20}
                    name={el.full_name}
                    icon={
                      (el.assignee_type === ASSIGNEE_TYPE.DEPARTMENT && <BankOutlined />) ||
                      (el.assignee_type === ASSIGNEE_TYPE.GROUP && <TeamOutlined />)
                    }
                  />
                </Tag>
              ))}
            </div>
          </Col>
        </Row>
        <Form.Item label={<span style={{ fontWeight: 500 }}>Tài liệu đính kèm:</span>} name={'id_file_dinh_kem'} style={{ marginTop: 24 }}>
          <Upload.Dragger
            valuePropName={'fileList'}
            fileList={fileList}
            multiple={true}
            onChange={handleChangeFile}
            beforeUpload={() => false}
            showUploadList={false}
            style={{ borderRadius: 12, background: '#fafafa', border: '1px solid #e8e8e8', padding: '32px 0' }}>
            <p className="ant-upload-drag-icon" style={{ marginBottom: 12 }}>
              <UploadOutlined style={{ color: '#a0aabf', fontSize: 48 }} />
            </p>
            <p className="ant-upload-text" style={{ fontWeight: 600, fontSize: 16, color: '#333', marginBottom: 8 }}>
              Kéo thả file, hình ảnh hoặc <span style={{ color: '#1890ff' }}>Tải lên</span>
            </p>
            <p className="ant-upload-hint" style={{ fontSize: 14, color: '#888' }}>
              Hỗ trợ: JPG, PNG, PDF, XLS, DOC, PPT &nbsp;<span style={{ color: '#e8e8e8' }}>|</span>&nbsp; Dung lượng tối đa: 100MB
            </p>
          </Upload.Dragger>
        </Form.Item>
        {fileList.length !== 0 && (
          <UploadFileListWrapper>
            {fileList.map(file => (
              <UploadFileListItem key={file.uid}>
                <FileTextOutlined />
                <span>{file.name}</span>
                <Tooltip title={'Xoá tập tin'}>
                  <DeleteOutlined
                    onClick={() =>
                      setFileList(fileList.filter(el => el.uid !== file.uid))
                    }
                  />
                </Tooltip>
              </UploadFileListItem>
            ))}
          </UploadFileListWrapper>
        )}
        {documentList.length !== 0 && (
          <UploadFileListWrapper>
            {documentList.map(file => (
              <UploadFileListItem key={file.id}>
                <FileTextOutlined style={{ color: blue }} />
                <span
                  onClick={() =>
                    fileStore.handleDownloadFile(file.id, file.name)
                  }
                  style={{
                    color: blue,
                    cursor: 'pointer',
                    textDecoration: 'underline',
                  }}>
                  {file.name}
                </span>
                <Tooltip title={'Xoá tập tin'}>
                  <DeleteOutlined
                    onClick={() =>
                      setDocumentList(
                        documentList.filter(doc => doc.id !== file.id)
                      )
                    }
                  />
                </Tooltip>
              </UploadFileListItem>
            ))}
          </UploadFileListWrapper>
        )}
        <ButtonFooter style={{ marginTop: 24 }}>
          <Space size={16}>
            <Button icon={<CloseOutlined />} danger onClick={handleCancel} style={{ borderRadius: 8, minWidth: 100, height: 40 }}>
              Hủy
            </Button>
            <Button
              icon={<SendOutlined />}
              type={'primary'}
              htmlType={'submit'}
              style={{ borderRadius: 8, minWidth: 120, height: 40 }}>
              Phân phát
            </Button>
          </Space>
        </ButtonFooter>
      </Form>
      <SelectPeoplePopup
        handleCancelSelectUser={handleCancelSelectUserDepartment}
        handleSubmitSelectUser={() =>
          setIsVisibleSelectUserDepartmentPopup(false)
        }
        isVisibleSelectPeoplePopup={isVisibleSelectUserDepartmentPopup}
      />
      <SelectGroupPopup
        isVisibleSelectGroupPopup={isVisibleSelectGroupPopup}
        handleCancelSelectGroup={handleCancelSelectGroup}
        handleSubmitSelectGroup={() => setIsVisibleSelectGroupPopup(false)}
      />
    </Modal>
    <style>{`
      .distribute-modal-custom .ant-modal-content {
        border-radius: 16px;
        overflow: hidden;
        background-color: #f0f4f8; /* Light blueish backdrop matching the image */
      }
      .distribute-modal-custom .ant-modal-header {
        background-color: #f0f4f8;
        border-bottom: none;
      }
      .distribute-modal-custom .ant-modal-body {
        background-color: #ffffff;
        margin: 0 16px 16px 16px;
        border-radius: 16px;
        padding: 24px;
        box-shadow: 0 2px 8px rgba(0,0,0,0.05);
      }
      .distribute-form-custom .ant-form-item-label > label {
        color: #555;
      }
      .distribute-form-custom .ant-select-selector {
        height: 40px !important;
        align-items: center;
        border-radius: 8px !important;
      }
    `}</style>
    </>
  )
}

PopupPhanPhatDocument.propTypes = {}
export default inject(
  'selectPeopleStore',
  'fileStore',
  'workStore',
  'loadingAnimationStore',
  'internalDocumentStore',
)(observer(PopupPhanPhatDocument))
